import React from "react";
import TableResult from "./component/tableResult";

export default function AdminPage(){
    return(
        <div className="fitur-all">
            <TableResult />
        </div>
    )
}